import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    CarouselContentDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    webStyle
} from "../../../../utils";

export const CAROUSEL_TOUCH_ACTIONS: Record<CarouselContentDynamicStyleType["orientation"], string> = {
    horizontal: "pan-y",
    vertical: "pan-x"
};

const stylesheet = StyleSheet.create({
    horizontal: {
        alignItems: "flex-start",
        flexDirection: "row",
        flexShrink: 0,
        width: "100%"
    },
    vertical: {
        flexDirection: "column",
        flexShrink: 0,
        width: "100%"
    }
});

export const useStyles = ({
    orientation,
    isMeasured,
    metrics,
    gap
}: Omit<CarouselContentDynamicStyleType, "spaces">) => {
    const styles = {
        container: {
            ...webStyle({
                touchAction: CAROUSEL_TOUCH_ACTIONS[orientation]
            }),
            gap
        } as Mutable<ViewStyle>
    };

    if(!isMeasured || metrics.totalSize <= 0) {
        return styles;
    }

    styles.container[orientation === "vertical" ? "height" : "width"] = metrics.totalSize;

    return styles;
};
export default stylesheet;
